import { Component, Input } from '@angular/core';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';

@Component({
  selector: 'app-pax-on-board-template',
  templateUrl: './pax-on-board-template.component.html',
  standalone: false,
})
export class PaxOnBoardTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;

  dateTimeFormat = DEFAULT_DATE_TIME_FORMAT;
}
